import { isIOS } from "mobile-device-detect";
import deferred from "vue-deferred";

var promises = {};

export default {
  makeid: function (length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },

  reqKaKaoPay: function (txId) {
    // sid List...
    // kakaopay - 카카오 페이 인증
    // fingerprint -
    return this.sendMessage("kakaopay", { tx_id: txId });
  },
  reqKaKaoSign: function (appScheme) {
    // sid List...
    // kakaopay - 카카오 인증
    // fingerprint -
    return this.sendMessage("kakaosign", { scheme: appScheme });
  },
  reqFingerPrint: function (params) {
    return this.sendMessage("fingerprint", params);
  },

  sendMessage: function (sid, params) {
    var defer = deferred();
    let id = this.makeid(9);

    promises[id] = { resolve: defer.resolve, reject: defer.reject };

    if (isIOS) {
      window.webkit.messageHandlers.ios_send_message_to_native.postMessage({
        promiseId: id,
        param: { sid: sid, ...params },
      });
    } else {
      window.android_send_message_to_native.postMessage(
        JSON.stringify({ promiseId: id, param: { sid: sid, ...params } })
      );
    }
    return defer.promise;
  },
};

window.android_recv_message_from_native = (str) => {
  let { promiseId, data, error } = JSON.parse(str);

  if (error) {
    promises[promiseId].reject(data);
  } else {
    promises[promiseId].resolve(data);
  }

  delete promises[promiseId];
};

window.ios_recv_message_from_native = (promiseId, data, error) => {
  if (error) {
    promises[promiseId].reject(data);
  } else {
    promises[promiseId].resolve(data);
  }

  delete promises[promiseId];
};
